import cls from "./Accordion.module.css";
import React, { useState } from "react";
import { useAnimatedMount } from "../../../hooks/useAnimatedMount/useAnimatedMount";
import { Overlay } from "../Overlay/Overlay";
import { classNames } from "../../../Utils/classNames/classNames";

interface AccordionProps {
    className?: string;
    label: string;
    items: string[];
    selectItem?: (item: string) => void;
    clear?: boolean;
    addonRight?: JSX.Element;
}
export const Accordion = (props: AccordionProps) => {
    const { className, items, clear, label, addonRight, selectItem } = props;
    const [isShowPopup, setIsShowPopup] = useState(false);
    const [selectedItem, setSelectedItem] = useState<string>();

    const [shouldRender, isActive] = useAnimatedMount(isShowPopup, 300);

    const showPopupHandler = () => {
        setIsShowPopup((prev) => !prev);
    };

    const onClickItem = (item: string) => () => {
        if (selectItem) {
            selectItem(item);
            setSelectedItem(item);
        }
    };

    const cancelSeleted = () => {
        if (selectItem) {
            selectItem("");
            setSelectedItem("");
        }
    };

    return (
        <>
            {shouldRender && <Overlay onClick={showPopupHandler} clear={clear} />}
            <div
                className={classNames(cls.accordion, { [cls.active]: isActive }, [className])}
                onClick={showPopupHandler}
            >
                <div className={cls.label}>
                    {selectedItem ? selectedItem : label}
                    {addonRight && (
                        <div className={classNames(cls.addonRight, { [cls.active]: isActive }, [className])}>
                            {addonRight}
                        </div>
                    )}
                </div>
                {shouldRender && (
                    <div className={classNames(cls.accordionItems, { [cls.active]: isActive }, [])}>
                        {items &&
                            items.map((item, index) => (
                                <React.Fragment key={index}>
                                    <div className={cls.item} onClick={onClickItem(item)}>
                                        {item}
                                    </div>
                                    {index < items.length - 1 && <hr className={cls.divider} />}
                                </React.Fragment>
                            ))}
                        <hr className={cls.divider} />
                        <div className={cls.item} onClick={cancelSeleted}>
                            Все
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
